import React from "react";

import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import JiraSecurityToolConfiLoginForm from "./JiraSecurityToolConfiLoginForm";
import JiraSecurityToolConfigListing from "./JiraSecurityToolConfigListing";

export default function JiraPullView(props: any) {
  return (
    <GenericPullAndPushToolView
      {...props}
      PullCredentialForm={JiraSecurityToolConfiLoginForm}
      PullConfigListingView={JiraSecurityToolConfigListing}
    />
  );
}
